module.exports = __webpack_public_path__ + "static/media/add.4a2e5e31.svg";